module.exports = __webpack_public_path__ + "img/plus.44864cba.svg";